import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';

export const supportedLngs = ['en', 'es', 'it', 'pt', 'fr'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path'], // detect language from the path
      lookupFromPathIndex: 0,
    },
  });

export default i18n;